import { useClientStore } from '~/stores/clients';
import { DEBUG, GLOBAL_MESSAGE_EVENT, type PayloadDataType } from './index';
import { useHelperStore } from '~/stores/helpers';

type ClientAdminAccess = {
  clientId: number;
  eventType?: 'ADD_CLIENT_ADMIN' | 'DELETE_CLIENT_ADMIN';
};

const getClientAdminMessage = (eventType?: ClientAdminAccess['eventType']) => {
  if (eventType === 'ADD_CLIENT_ADMIN') {
    return 'Customer Admin invited';
  }

  if (eventType === 'DELETE_CLIENT_ADMIN') {
    return 'Customer Admin removed';
  }

  return 'Customer admin successfully managed the Organization';
};

export async function handleUpdateClientAdminAccess(
  ...[_channel, data]: PayloadDataType<ClientAdminAccess>
) {
  if (DEBUG) console.log('handlePusherMessages', data);

  const piniaClient = useClientStore();
  const piniaHelper = useHelperStore();
  const emitter = useNuxtApp().$emitter;
  const { status } = piniaHelper.latestResponseStatus as { status: number };

  await piniaClient.getAdminContactsForClient(data.clientId);
  emitter.$emit(GLOBAL_MESSAGE_EVENT, {
    status,
    message: getClientAdminMessage(data.eventType),
    eventType: data.eventType ?? 'CHANNEL_ADMIN_ACCESS_GRANTED',
  });
}
